import React from "react";

// Cinematic vortex overlay played when leaving the Entry Page.
// Pure CSS animation. Component is unmounted after the animation completes.
export const VortexOverlay = () => {
  return (
    <div
      aria-hidden="true"
      className="kek-vortex-overlay"
      data-testid="kek-vortex-overlay"
    >
      <div className="kek-vortex" />
    </div>
  );
};

export default VortexOverlay;
